import type { ContactSupportViaServiceCloudVars } from '../types';

const URL_STRING = process?.env?.SERVICE_CLOUD_API_URL ?? '';
const METHOD = 'POST';

// This is the ID of a custom field created and maintained in Service Cloud
// intended to be used to capture the URL of the page the user was on when they
// submitted the contact support form.
const SERVICE_CLOUD_SUBMISSION_PAGE_URL_FIELD_ID =
  process?.env?.SERVICE_CLOUD_SUBMISSION_PAGE_FIELD_ID ?? '';

export const contactSupportViaServiceCloud = async ({
  formValues,
  formElement,
}: ContactSupportViaServiceCloudVars) => {
  const formData = new FormData(formElement ?? undefined);

  Object.entries(formValues).forEach((valueEntry) => {
    const [fieldName, fieldValue] = valueEntry;

    formData.set(fieldName, fieldValue);
  });

  const url = new URL(URL_STRING);

  const { characterSet, URL: currentPageUrl } = document;

  url.searchParams.set('encoding', characterSet);

  formData.set(SERVICE_CLOUD_SUBMISSION_PAGE_URL_FIELD_ID, currentPageUrl);

  // URLSearchParams should be able to take a formData object, but we are
  // getting a type error.
  const response = await fetch(url, {
    mode: 'no-cors',
    method: METHOD,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: new URLSearchParams(formData as any),
  });

  if (response.status !== 0) {
    throw new Error(`Error ${METHOD} ${url}: (Status: ${response.status})`);
  }

  return response;
};
